<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<table id="refund-ticket-price-type-list" mat-table orbitStickyTable [orbitStickyTable]="{ stickyRowActions: false }" [orbitTableDashboard]="false" [dataSource]="ticketsFormArray.controls" class="mat-elevation-z2">
  <!-- Ticket Type -->
  <ng-container matColumnDef="ticketType">
    <th mat-header-cell *matHeaderCellDef> Event Ticket Price Type </th>
    <td mat-cell *matCellDef="let group" class="info-label"> {{ group.value.ticketType }} </td>
    <td mat-footer-cell *matFooterCellDef class="info-label">Total</td>
  </ng-container>

  <!-- Ticket Number -->
  <ng-container matColumnDef="ticketNumber">
    <th mat-header-cell *matHeaderCellDef> Ticket Number </th>
    <td mat-cell *matCellDef="let group" class="info-label"> {{ group.value.ticketNumber }} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Ticket Price -->
  <ng-container matColumnDef="ticketPrice">
    <th mat-header-cell *matHeaderCellDef class="right"> Ticket Price  (£)</th>
    <td mat-cell *matCellDef="let group" class="info-label right"> {{ group.value.ticketPrice | number:'1.2-2' }} </td>
    <td mat-footer-cell *matFooterCellDef class="info-label right"> {{ getTotals().ticketPrice | number:'1.2-2' }} </td>
  </ng-container>

  <!-- Ticket Price Paid -->
  <ng-container matColumnDef="ticketPricePaid">
    <th mat-header-cell *matHeaderCellDef  class="right"> Ticket Price Paid  (£)</th>
    <td mat-cell *matCellDef="let group" class="info-label right"> {{ group.value.ticketPricePaid | number:'1.2-2' }} </td>
    <td mat-footer-cell *matFooterCellDef  class="info-label right"> {{ getTotals().ticketPricePaid | number:'1.2-2' }} </td>
  </ng-container>

  <!-- Ticket Type Refund Type -->
  <ng-container matColumnDef="ticketRefundType">
    <th mat-header-cell *matHeaderCellDef> Refund Ticket Price? </th>
    <td mat-cell *matCellDef="let group" [formGroup]="group">
      <mat-radio-group formControlName="ticketRefundType" class="refund-option-radio-group">
        <div class="flex-layout-column flex-layout-align-start">
          <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
            <span class="radio-button-text">{{ type.text }}</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Booking Fee -->
  <ng-container matColumnDef="bookingFee">
    <th mat-header-cell *matHeaderCellDef class="right"> Booking Fee  (£)</th>
    <td mat-cell *matCellDef="let group" class="info-label right"> {{ group.value.bookingFee | number:'1.2-2' }} </td>
    <td mat-footer-cell *matFooterCellDef class="info-label right"> {{ getTotals().bookingFee | number:'1.2-2' }} </td>
  </ng-container>

  <!-- Booking Fee Paid -->
  <ng-container matColumnDef="bookingFeePaid">
    <th mat-header-cell *matHeaderCellDef class="right"> Booking Fee Paid  (£)</th>
    <td mat-cell *matCellDef="let group" class="info-label right"> {{ group.value.bookingFeePaid | number:'1.2-2' }} </td>
    <td mat-footer-cell *matFooterCellDef class="info-label right"> {{ getTotals().bookingFeePaid | number:'1.2-2' }} </td>
  </ng-container>

  <!-- Booking Fee Refund Type -->
  <ng-container matColumnDef="bookingFeeRefundType">
    <th mat-header-cell *matHeaderCellDef> Refund Booking Fee? </th>
    <td mat-cell *matCellDef="let group" [formGroup]="group">
      <mat-radio-group formControlName="bookingFeeRefundType" class="refund-option-radio-group">
        <div class="flex-layout-column flex-layout-align-start">
          <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
            <span class="radio-button-text">{{ type.text }}</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Venue Levy -->
  <ng-container matColumnDef="venueLevy">
    <th mat-header-cell *matHeaderCellDef class="right"> Venue Levy  (£)</th>
    <td mat-cell *matCellDef="let group" class="info-label right"> {{ group.value.venueLevy | number:'1.2-2' }} </td>
    <td mat-footer-cell *matFooterCellDef class="info-label right"> {{ getTotals().venueLevy | number:'1.2-2' }} </td>
  </ng-container>

  <!-- Venue Levy Paid -->
  <ng-container matColumnDef="venueLevyPaid">
    <th mat-header-cell *matHeaderCellDef class="right"> Venue Levy Paid  (£)</th>
    <td mat-cell *matCellDef="let group" class="info-label right"> {{ group.value.venueLevyPaid | number:'1.2-2' }} </td>
    <td mat-footer-cell *matFooterCellDef class="info-label right"> {{ getTotals().venueLevyPaid | number:'1.2-2' }} </td>
  </ng-container>

  <!-- Venue Levy Refund Type -->
  <ng-container matColumnDef="venueLevyFeeRefundType">
    <th mat-header-cell *matHeaderCellDef> Refund Venue Levy? </th>
    <td mat-cell *matCellDef="let group" [formGroup]="group">
      <mat-radio-group formControlName="venueLevyFeeRefundType" class="refund-option-radio-group">
        <div class="flex-layout-column flex-layout-align-start">
          <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
            <span class="radio-button-text">{{ type.text }}</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Payment Status -->
  <ng-container matColumnDef="paymentStatus">
    <th mat-header-cell *matHeaderCellDef> Payment Status </th>
    <td mat-cell *matCellDef="let group" class="info-label"> {{ group.value.paymentStatus }} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Ticket Status -->
  <ng-container matColumnDef="ticketStatus">
    <th mat-header-cell *matHeaderCellDef> Ticket Status </th>
    <td mat-cell *matCellDef="let group" class="info-label"> {{ group.value.ticketStatus }} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Dispatch Status -->
  <ng-container matColumnDef="dispatchStatus">
    <th mat-header-cell *matHeaderCellDef> Issue Status </th>
    <td mat-cell *matCellDef="let group" class="info-label"> {{ group.value.dispatchStatus }} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Header & Row Definitions -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</table>
